import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg viewBox="0 0 1000 80" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect id="row1-details" x="2%" y="10" width="15%" height="15" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect id="row2-details" x="2%" y="30" width="15%" height="15" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect id="row3-details" x="2%" y="50" width="15%" height="15" rx="2" />
        </g>
    </svg>
);

const ListLoadingIndicator = (props) => (
    <RootWrapper {...props}>
        <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default ListLoadingIndicator;
